// Imperative in-app dialogs/toasts (replaces window.alert / confirm / prompt).
// AppDialogProvider registers the handlers at runtime.

let handlers = {
  alert: async (message) => {
    console.warn("[app-dialogs] Provider not mounted; falling back for:", message)
    return undefined
  },
  confirm: async () => false,
  prompt: async () => null,
  toast: (message) => {
    console.warn("[app-dialogs] Provider not mounted; toast:", message)
  },
}

export function registerAppDialogHandlers(next) {
  handlers = { ...handlers, ...next }
}

export function appAlert(message, options = {}) {
  return handlers.alert(String(message ?? ""), options)
}

export function appConfirm(message, options = {}) {
  return handlers.confirm(String(message ?? ""), options)
}

export function appPrompt(message, defaultValue = "", options = {}) {
  return handlers.prompt(String(message ?? ""), defaultValue == null ? "" : String(defaultValue), options)
}

export function appToast(message, options = {}) {
  handlers.toast(String(message ?? ""), options)
}
